import * as HttpService from "../../../../service/HttpService";
/* 
线损模型列表 
*/
export const getLineLossModelList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/line-loss-model/getLineLossModelList", params);
};

/* 
线损模型列表 
*/
export const getLineLossMeterList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/line-loss-model/getLineLossMeterList", params);
};
/* 
新增线损模型
*/
export const insertLineLossModel = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/line-loss-model/insertLineLossModel", params);
};

/* 
批量删除线损模型
*/
export const deleteLineLossModel = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/line-loss-model/deleteLineLossModel", params);
};
